<template>
  <div>
      <el-tabs v-model="activeName" @tab-click="handleClick" style="height:100%">
        <el-tab-pane label="佣金收入" name="first" style="height:100%">
          <selectedFirst @selectedFirst='selectedFirstvalue'></selectedFirst>
        </el-tab-pane>
        <el-tab-pane label="提现记录" name="second" style="height:100%">
          <withdrawalRecordSPage></withdrawalRecordSPage>
        </el-tab-pane>   
      </el-tabs>    
     <div class="derive" v-show="isderive" style="position: fixed; top: 60px;">
        <button type="submit" class="btn btn-primary" @click="ExportAll()" style="float:right;font-size:12px;color:#fff;margin-right:5px;">
        <a id="Exportlink" href=""  ref="test"></a>
        <i class="fa fa-download  "></i> 导出</button>
     </div>
           <div class="del-mask">
          <div class="mask_box">
              <div class="panel panel-default  no-border">
                <!-- Default panel contents -->
                <div class="panel-heading">导出所有</div>
                <div class="panel-body">
                  <form class="form-inline form-inline1" novalidate="" role="form">
                    <div>
                      <div class="error3">
                         <div class="messageinfo"></div>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="closed closed-del" @click="closeDelMask()">×</div>
                <!-- Table -->
                <p>
                  <span class="fr">
                    <button type="button"  class="btn btn-info ExportAlls" style="color:#fff !important;" @click="closeDelMask1()">跳转到导出页面</button>
                  </span>
                  <span class="fr">
                    <button type="button" class="btn btn-default btn-q btn-q-del" @click="closeDelMask()">取消</button>
                  </span>
                </p>
              </div>
          </div>
        </div>
  </div>
</template>

<script>
import selectedFirst from "./commissionRevenue/commissionRevenueS.vue";
import withdrawalRecordSPage from "./withdrawalRecord/withdrawalRecordS.vue";
export default {
  // 我的账户查询
  name: "accountreports",
  data() {
    return {
      activeName: "first",
      isderive:true,
      tabname:"first",
      selectedFirstobj:""
    };
  },
  components: {
    selectedFirst,
    withdrawalRecordSPage
  },
  watch: {
    tabname(val){
      if(this.tabname == "second"){
          this.isderive = false
      }else{
          this.isderive = true;
      }
    }
  },
  created() {
    this.$store.state.loaction = "/selects/accountreports";
  },
  methods: {
    handleClick(tab, event) {
      this.tabname = tab.name;
    },
    selectedFirstvalue(val){
      this.selectedFirstobj = val
    },
        // 导出
    ExportAll() {
              let url = "";
              let postData = {};
              if(this.tabname == "first"){   //持仓
                url = "report/ExportAgentDayCommissionHistory"
                postData = {
                  BeginDate:this.selectedFirstobj.BeginDate,
                  EndDate:this.selectedFirstobj.EndDate
                }
              }
              this.$loginapi.post(url, postData, response => {
                if (response.Ret == 0) {

                    $(".del-mask").fadeIn("fast");
                    $('.messageinfo').html(response.Msg);
                   
                } else {
                  this.$message.error(response.Msg);
                }
              });
        },
        closeDelMask() {
          $(".del-mask").fadeOut("fast");
        },
        closeDelMask1() {

          $(".del-mask").fadeOut("fast");
          this.$router.push('/selects/exportdown');

        }
  }
};
</script>

<style scoped>
.derive{
    position: absolute;
    right: 10px;
    top: 155px;
}
</style>



// WEBPACK FOOTER //
// src/components/selects/accountreports.vue